import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { FiscaisForm } from "../modais"
class FiscaisCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/fiscais")
  }
  render() {
    return (
      <Layout tabActive="Fiscais de contrato">
        <FiscaisForm callBackFiscais={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(FiscaisCreateForm)



// WEBPACK FOOTER //
// ./src/views/fiscais/FiscaisCreateForm.js